import React from 'react';
import ServiceLayout from '../layouts/ServiceLayout';

const ManualTherapy = () => {
  const serviceData = {
    title: "Manual Therapy",
    image: "/Manual Therapy.png",
    description: "Our manual therapy service provides specialized hands-on treatment techniques to reduce pain, improve mobility, and restore function to joints and soft tissues.",
    benefits: [
      "Immediate pain relief",
      "Improved joint mobility",
      "Enhanced tissue healing",
      "Better muscle function",
      "Reduced stiffness",
      "Faster recovery"
    ],
    approach: [
      "Joint mobilization and manipulation",
      "Soft tissue mobilization",
      "Myofascial release",
      "Trigger point therapy",
      "Stretching techniques",
      "Neural mobilization"
    ]
  };

  return <ServiceLayout {...serviceData} />;
};

export default ManualTherapy; 